var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative search-by-pic relative"},[_c('span',{staticClass:"iconfont font-40"},[_vm._v("")]),_c('input',{ref:"camera",staticClass:"upload-input",attrs:{"capture":"camera","type":"file","accept":"image/*"},on:{"change":_vm.handlerToUploadImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }